import React from "react";
import "./errorBanner.css";
import CloseIcon from "../../../assets/images/survey/close.svg";
import BulletIcon from "../../../assets/images/survey/Bullet.svg";

const ErrorBanner = ({ show, message }) => {
  if (!show) return null;

  return (
    <div className="error-banner-sticky">
      <div className="error-banner-close-icon">
        <img src={CloseIcon} alt="Close" className="close-icon-img" />
      </div>
      <div className="error-banner-content">
        <div className="error-icon-container">
          <img src={BulletIcon} alt="Bullet" />
        </div>
        <div className="error-text-container">
          <span className="error-text">{message}</span>
        </div>
      </div>
    </div>
  );  
};

export default ErrorBanner;

